
import { defineComponent } from 'vue';
import Footer from '@/components/footer/index.vue';
import HeadNav from '@/components/headNav/index.vue';
export default defineComponent({
  components: {
    Footer,
    HeadNav,
  },
})

//  移除没用的检测代码的仓库
//     "@vue/eslint-config-typescript": "^9.1.0",
//     "eslint": "^7.32.0",
//     "eslint-plugin-vue": "^8.0.3",
//     "@vue/cli-plugin-eslint": "~5.0.0",
//     "@typescript-eslint/eslint-plugin": "^5.4.0",
//     "@typescript-eslint/parser": "^5.4.0",


